import React, { Component } from 'react'
import { Field, reduxForm, SubmissionError } from 'redux-form'
import { connect } from 'react-redux'
import { Row } from '@sketchpixy/rubix'
import * as MabnaButton from '../common/Button/Button'
import { NotificationManager } from 'react-notifications'
import { browserHistory } from 'react-router'
import { createFormData } from '../../helpers/utility'
import { BROADCAST_MESSAGE_REQUEST } from '../../actions/actions'
import {genericRadioButtonGroup, AsyncAutoCompleteSelect, fileInput} from '../common/FormFields/Fields'
import GridedRow from '../common/GridedRow/GridedRow'
import api from '../../api/api'

const formSelector = 'Broadcast'
const styles = {
  textarea: {
    padding: '10px',
    marginTop: '20px',
    borderRadius: 5,
    borderColor: 'grey',
    width: '100%'
  },
  label: {
    marginRight: '10px',
  },
}

const excelRequired = [
  'student',
  'school',
]

const loadReceiverOptions = (data, callback) => {
  api
    .getSupportReceiversList(`search=${data}`)
    .then(res => {
      const receivers = res.data.data.users

      return callback(receivers.map( (item) => {
        return {
          label: item.display_name,
          value: item.id,
        }
      }))
    })
    .catch(err => {
      console.log(err)
      return []
    })
}

class Broadcast extends Component {
  text = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <div>
        <Row className="form-row">
          <textarea
            style={styles.textarea}
            rows={4}
            name="info"
            id="info"
            placeholder="متن پیام"
            {...input}
            {...custom}
          />
        </Row>
        <div className="form-error">{hasError && error}</div>
      </div>
    )
  }

  onCancelRequest = () => {
    browserHistory.push('/dashboard/messages/broadcasts')
  }

  normalizeSelectValues = ( formValues ) => {
    const {receiver} = formValues
    const receiverIds = receiver && receiver.length > 0? receiver.map( item => item.value ) : null

    return {
      ...formValues,
      receiver: receiverIds,
    }
  }

  handleSubmit = values => {
    const { dispatch } = this.props
    let formData = createFormData(this.normalizeSelectValues(values))

    return new Promise((resolve, reject) => {
      dispatch({
        type: BROADCAST_MESSAGE_REQUEST,
        formData,
        resolve,
        reject,
      })
    })
      .then(() => {
        NotificationManager.success('پیام شما ارسال شد', null, 6000)
        browserHistory.push('/dashboard/messages/broadcasts')
      })
      .catch(errors => {
        throw new SubmissionError({
          _error: errors.general_errors[0],
          ...errors.form_errors,
        })
      })
  }

  receivingGroupsOptions = [
    // { value: 'student', name: 'دانش آموزان' },
    // { value: 'teacher', name: 'معلمان' },
    // { value: 'school', name: 'مدارس' },
    // { value: 'supervisor', name: 'نماینده ها' },
    { id: 'student', title: 'دانش آموزان' },
    // { id: 'teacher', title: 'معلمان' },
    { id: 'school', title: 'مدارس' },
    { id: 'supervisor', title: 'نماینده ها' },
  ]

  isFileInputNeeded = () => {
    const values = this.props.formProps && this.props.formProps.values
    const via_file = values && values.via_file

    return this.isNotSupervisor() && (via_file === 'true')
  }

  isNotSupervisor = () => {
    const values = this.props.formProps && this.props.formProps.values
    return values && excelRequired.includes(values.receiving_groups)
  }

  isListNeeded = () => {
    const values = this.props.formProps && this.props.formProps.values
    const via_file = values && values.via_file

    return values && this.isNotSupervisor() && (via_file === 'false')
  }

  isSchool = () => {
    const values = this.props.formProps && this.props.formProps.values
    return values && values.receiving_groups === 'school'
  }

  render() {
    const { handleSubmit } = this.props

    return (
      <div className="compose-message message-page">
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <div style={{ marginBottom: 20 }}>
            <h5>ارسال پیام دسته جمعی</h5>
            {/* <small>لطفا گروه دریافت کننده را انتخاب کنید</small> */}
          </div>

          <Field
            name="receiving_groups"
            fieldName="receiving_groups"
            title="لطفا گروه دریافت کننده را انتخاب کنید"
            className="horizontal-options"
            // component={this.receivingGroups}
            // options={this.receivingGroupsOptions}
            component={genericRadioButtonGroup}
            options={this.receivingGroupsOptions}
          />

          {/* {this.isNotSupervisor() && <Field
            name="via_file"
            fieldName="via_file"
            title="شیوه انتخاب گیرنده‌های مورد نظر"
            className="horizontal-options"
            component={genericRadioButtonGroup}
            options={[
              { id: 'true', title: 'آپلود فایل' },
              { id: 'false', title: 'انتخاب لیست' },
            ]}
          />} */}

          {this.isNotSupervisor()
            && <Field
                name="excel"
                fieldName="excel"
                title="بارگذاری فایل"
                component={fileInput}
                accept='.xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
              />
          }

          {this.isSchool() &&
            <Field
              title="لیست دریافت‌کنندگان"
              fieldName="receiver"
              name="receiver"
              isMulti={true}
              component={AsyncAutoCompleteSelect}
              loadOptions={loadReceiverOptions}
              noOptionsMessage={() => 'نام یا نام کاربری مرکز آموزشی مورد نظر را وارد نمایید'}
            />
          }

          <Field name="text" component={this.text} />

          <div className="button-row">
            <MabnaButton.Primary type="submit" value="Submit">
              ارسال
            </MabnaButton.Primary>

            <MabnaButton.Primary
              type="button"
              outline
              onClick={this.onCancelRequest}
            >
              بازگشت
            </MabnaButton.Primary>
          </div>
        </form>
      </div>
    )
  }
}

const validate = values => {
  let errors = {}

  if (!values.text) {
    errors.text = 'متن پیام جهت ارسال پیام به مدیریت الزامی است'
  }

  if (!values.receiving_groups) {
    errors.receiving_groups = 'گروه های دریافت کننده را وارد کنید'
  }

  if (values.receiving_groups && values.receiving_groups.length === 0) {
    errors.receiving_groups = 'انتخاب حداقل یک گروه الزامیست'
  }

  return errors
}

Broadcast = reduxForm({
  form: formSelector,
  validate,
})(Broadcast)

const mstp = state => {
  return {
    formProps: state.form[formSelector]
  }
}

export default connect(mstp)(Broadcast)



// WEBPACK FOOTER //
// ./src/components/manager/ManagerBroadcast.js